import { AppState } from '../rootReducer';

export const getSelectedLocations = (store: AppState): string[] => store.locationSelector.selectedLocations;
export const getTestGroupSelectedLocations = (store: AppState): string[] =>
  store.locationSelector.testGroup.selectedLocations;
export const getControlGroupSelectedLocations = (store: AppState): string[] =>
  store.locationSelector.controlGroup.selectedLocations;
export const getLocationsSearchData = (store: AppState) => store.locationSelector.search;
export const getIsContactsWithoutLocations = (store: AppState) => store.locationSelector.isContactsWithoutLocations;
